module.exports = __webpack_public_path__ + "static/media/Figma.c7ef6766.svg";